import SlideShow from './slide_show';

export default SlideShow;
